import convertType from "../types-converter";

export default function converterObjectPropertiesTypes(object) {
  return Object.keys(object).reduce(
    (acc, key) => ({ ...acc, [key]: convertType(object[key]) }),
    {}
  );
}
